import {
  Box,
  Button,
  Drawer,
  Skeleton,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Controller, useForm } from "react-hook-form";
import { rem, isWeb, maxLen } from "assets/js/common";
import axios from "axios";
import React, { useEffect, useState, Suspense } from "react";
import moment from "moment";
import ImageDrawer from "components/ui/image-drawer";
import { useDispatch, useSelector } from "react-redux";
import { loadCommentListAction } from "redux/reducers/event/index";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams, useHistory } from "react-router-dom";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import _ from "lodash";
import { Cookies } from "react-cookie";
import { upload, getAppData } from "assets/js/apphandle";
import { loadAlert } from "redux/reducers/top";
import jwt_decode from "jwt-decode";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";

const useStyles = makeStyles((theme) => ({
  comment: {
    "& .regBtn": {
      padding: `0 ${rem(30)}`,
    },
    "& .input-section": {
      padding: rem(30),
      //   "& .MuiTextField-root": {
      //     "& .MuiInputBase-root": {
      //       height: rem(310),
      //       "& input": {
      //         height: rem(310),
      //       },
      //     },
      //   },
      "& .img-list": {
        display: "flex",
        justifyContent: "flex-start",
        "& .img-item": {
          position: "relative",
          margin: `${rem(15)} ${rem(8)} 0 0`,
          width: rem(80),
          height: rem(80),
          display: "block",
          "& img": {
            width: rem(60),
            height: rem(60),
            borderRadius: rem(10),
            marginRight: rem(6),
          },
          "& .img-close": {
            position: "absolute",
            top: rem(-3),
            right: rem(-3),
            maxWidth: rem(20),
            maxHeight: rem(20),
            minWidth: "auto",
            "& img": {
              width: rem(20),
              height: rem(20),
              margin: 0,
            },
          },
        },
      },
      "& .bottom-wrap": {
        "& label": {
          "& img": {
            // paddingRight: rem(5),
          },
          "& + button": {
            margin: `${rem(10)} 0 0 0`,
          },
        },
      },
    },
    "& .comment-cnt": {
      fontSize: rem(14),
      fontWeight: 700,
      color: `#8E8E8E`,
      padding: `${rem(40)} ${rem(30)} ${rem(15)}`,
      borderBottom: `1px solid #EEEEEE`,
    },
    "& .comment-list": {
      padding: `${rem(30)}`,
      "& .name": {
        fontWeight: 700,
      },
      "& .content": {
        paddingTop: rem(5),
        fontSize: rem(14),
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        fontFamily:
          "'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
      },
      "& .img": {
        padding: `${rem(15)} 0 ${rem(4)}`,
        flex: 1,
        "& img": {
          width: rem(60),
          height: rem(60),
          borderRadius: rem(10),
          marginRight: rem(6),
        },
        "& .image-loader": {
          marginRight: rem(8),
          display: "inline-block",
          "&:before": {
            display: "none",
          },
        },
      },
      "& .bottom": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: rem(20),
        fontSize: rem(12),
        color: "#8E8E8E",
        "& span": {
          fontSize: rem(13),
          fontWeight: 800,
        },
        "& .func-btn": {
          display: "flex",
          alignItems: "center",
          "& img": {
            width: rem(24),
            height: rem(24),
          },
          "& button": {
            minWidth: rem(40),
            "& + button": {
              marginLeft: rem(12),
            },
          },
        },
      },
      "& +.comment-list": {
        borderTop: `1px solid #EEEEEE`,
      },
      "& .top": {
        display: "flex",
        justifyContent: "space-between",
        "& .textBtn": {
          "& button": {
            display: "inline-block",
            position: "relative",
            minWidth: "auto",
            fontWeight: "400",
            fontSize: rem(14),
            "& + button": {
              marginLeft: rem(10),
              paddingLeft: rem(10),
              "&:before": {
                top: "50%",
                left: 0,
                width: "1px",
                height: "50%",
                content: "''",
                position: "absolute",
                transform: "translateY(-50%)",
                backgroundColor: theme.palette.grey[100],
              },
            },
          },
        },
      },
    },
    "& .MuiInputBase-multiline": {
      "& .MuiInputAdornment-root": {
        width: "100%",
        display: "block",
        lineHeight: rem(16),
        textAlign: "right",
      },
    },
  },
}));

const cookies = new Cookies();

export default function Comment(props) {
  // const [no, setNo] = useState("");
  // const [token, setToken] = useState("");

  const token = cookies.get("X-AUTH-TOKEN");
  const no = cookies.get("no");

  const classes = useStyles();
  const dispatch = useDispatch();
  const [openDrawer, setOpenDrawer] = useState(false);
  const { seq } = useParams();
  const { cmForm, commentList, loadingCmt, event } = useSelector(
    (state) => state.event
  );
  const [selectedItem, setSelectedItem] = useState("regist");
  const [initialized, setInitialized] = useState(true);
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      seq: "",
      evSeq: "",
      cont: "",
      imgUrl1: "",
      imgUrl2: "",
      imgUrl3: "",
    },
  });

  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [alertMode, setAlertMode] = useState("");
  const [imgUrl, setImgUrl] = useState([]);
  const [updateImgUrl, setUpdateImgUrl] = useState([]);
  const history = useHistory();

  const [rows, setRows] = useState({
    list: [],
    totalPageSize: 0,
  });

  const handleUploadImg = () => {
    if (imgUrl.length > 2) {
      setAlertMode("file");
      setOpen(true);
      return;
    }

    window.appUploadHandle1 = (id, url) => {
      setImgUrl([...imgUrl, url]);
    };

    location.href = `csrmegamart://upload?server=image&type=gallery&func=appUploadHandle1&wfunc=appUploadWrong&id=1`;
  };

  const handleAlertClose = () => {
    setOpen(false);
  };
  const handleWebUploadImg = (e) => {
    let file = e.target.files[0];

    let formData = new FormData();
    if (file) {
      let fileNm = e.target.files[0].name;
      let ext = fileNm.substring(fileNm.lastIndexOf(".") + 1, fileNm.length);
    }

    let url = `/api/st/attach-image/upload?domain=image`;
    formData.append("image", e.target.files[0]);

    axios
      .post(url, formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=<calculated when request is sent>",
        },
      })
      .then((res) => {
        setValue(`imgUrl${imgLength}`, res.data.data);
      });
  };

  const handleInfiniteScroll = () => {
    console.log("handleInfiniteScroll");
    if (cmForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }

    dispatch(
      loadCommentListAction({ pg: cmForm.pg + 1, pgSz: 10, evSeq: seq })
    );
  };

  useEffect(() => {
    if (openDrawer) onReset();
  }, [openDrawer]);

  const goLogin = () => {
    history.push({
      pathname: "/login",
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
  };
  const onSubmit = (data) => {
    // let token = cookies.get("X-AUTH-TOKEN");
    // if (!token) {
    //   setAlertMode("login");
    //   setOpen(true);
    //   return;
    // }

    if (getValues("cont")) {
      handleComment();
    } else {
      handleAlertOpen("valid");
    }
  };

  const handleComment = () => {
    let form = {
      ...getValues(),
    };

    imgUrl.map((item, i) => {
      form[`imgUrl${i + 1}`] = item;
    });

    axios.post(`/api/eh/event-comment/${drawerMode}`, form).then((res) => {
      handleDrawerClose();
      handleAlertOpen(`${drawerMode}Comp`);
    });
  };

  const init = () => {
    setRows({
      ...rows,
      list: [],
    });
    dispatch(
      loadCommentListAction({
        ...cmForm,
        pg: 1,
      })
    );
    setValue("cont", "");
  };

  window.appBackKeyHandle = () => {
    if (open) {
      if (alertMode == "registComp") {
        handleAlertClose();
        handleDrawerClose();
        dispatch(loadCommentListAction(cmForm));
        setValue("cont", "");
      } else if (alertMode == "modifyComp") {
        handleAlertClose();
        handleDrawerClose();
        dispatch(loadCommentListAction(cmForm));
      } else {
        handleAlertClose();
      }
    } else if (openDrawer) {
      handleDrawerClose();
    } else {
      history.goBack();
    }
  };

  const handleDelete = () => {
    handleAlertClose();
    axios
      .post("/api/eh/event-comment/remove", null, {
        params: {
          seq: selectedItem.seq,
        },
      })
      .then((res) => {
        dispatch(loadCommentListAction({ pg: 1, pgSz: 10, evSeq: seq }));
      });
  };

  watch("cont", false);
  watch("imgUrls", false);

  const handleFav = (item, i) => {
    console.log("i", i);
    if (token) {
      axios
        .post("/api/eh/event-comment/like", {
          seq: item.seq,
        })
        .then((res) => {
          let data = res.data.data;
          item = {
            ...item,
            favCnt: data == "Y" ? item.favCnt + 1 : item.favCnt - 1,
            favYn: data,
          };
          const ll = [...rows.list];
          ll.splice(i, 1, item);
          setRows({
            ...rows,
            list: ll,
          });
        });
      console.log("rows", rows.list);
    } else {
      dispatch(loadAlert(true));
    }
  };

  const handleAlertOpen = (mode) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAction = (item, i) => {
    setSelectedItem({
      ...item,
      i: i,
    });
    handleAlertOpen("delConfirm");
  };
  const checkAlertType = (item, i) => {
    if (token) {
      handleAlertOpen(item.rptYn == "Y" ? "cancelConfirm" : "reportConfirm");

      setSelectedItem({
        ...item,
        i: i,
      });
    } else {
      dispatch(loadAlert(true));
    }
  };
  const handleRpt = () => {
    setOpen(false);
    axios
      .post("/api/eh/event-comment/report", {
        seq: selectedItem.seq,
      })
      .then((res) => {
        let data = res.data.data;
        if (data == "Y") {
          handleAlertOpen("reportComp");
        }

        let item = {
          ...selectedItem,
          rptCnt:
            data == "Y" ? selectedItem.rptCnt + 1 : selectedItem.rptCnt - 1,
          rptYn: data,
        };
        const ll = [...rows.list];
        ll.splice(selectedItem.i, 1, item);
        setRows({
          ...rows,
          list: ll,
        });
      });
  };

  const imgLength =
    getValues("imgUrl1") && getValues("imgUrl2") && getValues("imgUrl3");

  const handleFileUpload = async (file) => {
    console.log("file", file);
    let formData = new FormData();
    formData.append("file", file);

    let result = "";
    await axios
      .post(`/api/st/s3/upload?domain=comment`, formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=<calculated when request is sent>",
        },
      })
      .then((res) => {
        console.log("res.data.data", res.data.data);
        result = res.data.data;
      });
    return result;
  };

  const handleImgDelete = (e, i) => {
    let urls = [...imgUrl];
    urls.splice(i, 1);
    setImgUrl(urls);
  };
  const handleWebFileUpload = async (e) => {
    console.log("e", e);
    const files = e.target.files;

    if (imgUrl.length + Object.keys(files).length > 3) {
      setAlertMode("file");
      setOpen(true);
      return;
    }
    let result = [];
    console.log("files", files);
    for (let file of files) {
      result.push(await handleFileUpload(file));
    }
    setImgUrl([...imgUrl, ...result]);
  };

  const handleUpdateImgDelete = (e, i) => {
    let urls = [...updateImgUrl];
    urls.splice(i, 1);
    setUpdateImgUrl(urls);
  };

  const [drawerMode, setDrawerMode] = useState("");
  const handleDrawerOpen = (mode, item) => {
    setDrawerMode(mode);
    setSelectedItem(item);
    setOpenDrawer(true);
  };
  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const onReset = () => {
    if (drawerMode == "regist") {
      reset({
        seq: "",
        evSeq: seq,
        cont: "",
        imgUrl1: "",
        imgUrl2: "",
        imgUrl3: "",
      });
      setImgUrl([]);
    } else if (drawerMode == "modify") {
      reset({
        seq: selectedItem.seq,
        evSeq: seq,
        cont: selectedItem.cont,
        imgUrl1: "",
        imgUrl2: "",
        imgUrl3: "",
      });

      let imgs = [
        selectedItem.imgUrl1,
        selectedItem.imgUrl2,
        selectedItem.imgUrl3,
      ];

      imgs = imgs.filter((element, i) => element != null);
      setImgUrl(imgs);
    }
  };

  const checkRegist = () => {
    if (token) {
      handleDrawerOpen("regist");
    } else {
      dispatch(loadAlert(true));
    }
  };

  useEffect(() => {
    onReset();
  }, [selectedItem]);

  useEffect(() => {
    dispatch(loadCommentListAction({ pg: 1, pgSz: 10, evSeq: seq }));
    onReset();
  }, []);

  useEffect(() => {
    // if (commentList && commentList.list.length > 0) {
    if (commentList) {
      if (cmForm.pg == "1") {
        setRows({
          ...commentList,
        });
      } else {
        setRows({ ...commentList, list: [...rows.list, ...commentList.list] });
      }
    }
  }, [commentList]);

  return (
    <div className={classes.comment + " fav-comment"}>
      {/* <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-section bg-grey">
          <TextField
            //   label="Multiline"
            multiline
            placeholder="댓글을 입력해주세요."
            variant="standard"
            inputProps={{
              maxLength: 200,
              style: { height: "100%", overflow: "scroll" },
            }}
            id="cont"
            {...register("cont")}
            onChange={(e) => {
              setValue("cont", maxLen(e.target.value, 200));
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="bottom">
                  <span className="count">
                    {getValues("cont").length}
                    /200
                  </span>
                </InputAdornment>
              ),
            }}
            style={{ height: "310px" }}
          />
          {imgUrl.length > 0 && (
            <ul className="img-list">
              {imgUrl.map((item, i) => (
                <li className="img-item" key={i}>
                  <LazyCDNImage
                    key={item}
                    cdnUrl={item}
                    style={{ width: "80px", height: "80px" }}
                  />
                  <Button
                    className="img-close"
                    onClick={(e) => {
                      handleImgDelete(e, i);
                    }}
                  >
                    <img
                      src={`${
                        process.env.PUBLIC_URL
                      }/images/icon/img-close.svg`}
                    />
                  </Button>
                </li>
              ))}
            </ul>
          )}
          <div className="bottom-wrap">
            {isWeb ? (
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                component="label"
              >
                <img src={`${process.env.PUBLIC_URL}/images/icon/image.svg`} />
                사진첨부
                <span className="cnt">{imgUrl.length}/3</span>
                <input
                  type="file"
                  accept="image/*"
                  value=""
                  hidden
                  multiple
                  onChange={(e) => {
                    handleWebFileUpload(e);
                  }}
                />
              </Button>
            ) : (
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                onClick={handleUploadImg}
              >
                <img src={`${process.env.PUBLIC_URL}/images/icon/image.svg`} />
                사진첨부
                <span className="cnt">{imgUrl.length}/3</span>
              </Button>
            )}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              style={{ marginLeft: 0 }}
            >
              등록하기
            </Button>
          </div>
        </div>
      </form> */}

      <Box pb={11}>
        {/* {loadingCmt && rows.list.length == 0 ? (
          <div className="board-list">
            {Array.from(Array(6)).map((_, index) => (
              <div className="item" key={index}>
                <Box p={6} pt={0}>
                  <Skeleton height={30} />
                  <Skeleton height={30} width={100} />
                </Box>
              </div>
            ))}
          </div>
        ) : */}

        {
          <>
            {moment(props.item.evtStrtYmd) <= moment(moment().format("YYYYMMDD")) && moment(props.item.evtEndYmd) >= moment(moment().format("YYYYMMDD")) && (
              <div className="regBtn">
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={() => checkRegist()}
                >
                  댓글 등록
                </Button>
              </div>
            )}

            {rows.list.length > 0 && (
              <InfiniteScroll
                dataLength={rows.list.length}
                next={handleInfiniteScroll}
                hasMore={setInitialized}
                inverse={false}
              >
                <div className="comment-cnt">댓글 {rows.totalSize}개</div>
                <ul>
                  {rows.list.map((item, i) => (
                    <li className="comment-list" key={i}>
                      <div className="top">
                        <div className="name">{item.mbrNm}</div>
                        {token && item.mbrNo == no && (moment(props.item.evtStrtYmd) <= moment(moment().format("YYYYMMDD")) && moment(props.item.evtEndYmd) >= moment(moment().format("YYYYMMDD"))) && (
                          <div className="textBtn">
                            <Button
                              size="small"
                              color="info"
                              onClick={() => handleDrawerOpen("modify", item)}
                            >
                              수정
                            </Button>
                            <Button
                              size="small"
                              color="info"
                              onClick={() => handleAction(item)}
                            >
                              삭제
                            </Button>
                          </div>
                        )}
                      </div>

                      <div className="content">{item.cont}</div>
                      {item.imgUrl1 && (
                        <div className="img">
                          <ImageDrawer item={item} key={item.seq} />
                        </div>
                      )}
                      <div className="bottom">
                        <div className="date">
                          {moment(item.rgstYmd).format("YYYY.MM.DD(ddd)")}
                        </div>
                        {moment(props.item.evtStrtYmd) <= moment(moment().format("YYYYMMDD")) && moment(props.item.evtEndYmd) >= moment(moment().format("YYYYMMDD")) && (
                          <div className="func-btn">
                            <Button
                              className="report"
                              onClick={() => {
                                checkAlertType(item, i);
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL
                                  }/images/icon/report${item.rptYn == "Y" ? "-on" : "-off"
                                  }.svg`}
                              />
                              <span
                                style={{
                                  color:
                                    item.rptYn == "Y" ? "#000000" : "#CCCCCC",
                                }}
                              >
                                {item.rptCnt}
                              </span>
                            </Button>
                            <Button
                              className="fav"
                              onClick={() => {
                                handleFav(item, i);
                              }}
                            >
                              <img
                                src={`${process.env.PUBLIC_URL
                                  }/images/icon/favorite${item.favYn == "Y" ? "" : "-off"
                                  }.svg`}
                              />
                              <span
                                style={{
                                  color:
                                    item.favYn == "Y" ? "#F1270B" : "#CCCCCC",
                                }}
                              >
                                {item.favCnt}
                              </span>
                            </Button>
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </InfiniteScroll>
            )}
          </>
        }
      </Box>
      {alertMode == "valid" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"댓글을 입력해주세요"}
            action={() => {
              handleAlertClose();
              document.querySelector("#cont").focus();
            }}
          />
        </>
      ) : alertMode == "registComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"댓글이 등록되었습니다."}
            action={() => {
              handleAlertClose();
              handleDrawerClose();
              dispatch(loadCommentListAction(cmForm));
              setValue("cont", "");
            }}
          />
        </>
      ) : alertMode == "modifyComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"댓글이 수정되었습니다."}
            action={() => {
              handleAlertClose();
              handleDrawerClose();
              dispatch(loadCommentListAction(cmForm));
            }}
          />
        </>
      ) : alertMode == "reportComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"신고가 완료되었습니다."}
            action={handleAlertClose}
          />
        </>
      ) : alertMode == "reportConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 댓글을 신고하시겠습니까?"}
          action={() => {
            handleRpt();
          }}
        />
      ) : alertMode == "file" ? (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text={"이미지는 3개까지 첨부 가능합니다."}
          action={handleAlertClose}
        />
      ) : alertMode == "delConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 댓글을 삭제하시겠습니까?"}
          action={() => {
            handleDelete();
          }}
        />
      ) : alertMode == "login" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={`로그인이 필요한 서비스입니다.<br/>로그인 하시겠습니까?`}
          action={goLogin}
        />
      ) : (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 댓글의 신고를 취소하시겠습니까?"}
          action={() => {
            handleRpt();
          }}
        />
      )}

      <Drawer
        anchor="bottom"
        open={openDrawer}
        onClose={handleDrawerClose}
        className="drawer-common-bottom size-high title-center"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="drawer-head">
            <h3>댓글 {drawerMode == "modify" ? "수정" : "등록"}</h3>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={handleDrawerClose}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </div>
          <div className="drawer-body">
            <div className={classes.comment + " fav-comment"}>
              <div
                className="input-section bg-grey"
                style={{ height: "calc(100vh - 210px)" }}
              >
                <TextField
                  //   label="Multiline"
                  multiline
                  rows={8}
                  placeholder="댓글을 입력해주세요."
                  variant="standard"
                  inputProps={{
                    maxLength: 200,
                    style: { height: "100%", overflow: "scroll" },
                  }}
                  id="cont"
                  {...register("cont")}
                  onInput={(e) => {
                    let value = maxLen(e.target.value, 200);
                    setValue("cont", value);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="bottom">
                        <span className="count">
                          {watch("cont").length}
                          /200
                        </span>
                      </InputAdornment>
                    ),
                  }}
                />
                {imgUrl.length > 0 && (
                  <ul className="img-list">
                    {imgUrl.map((item, i) => (
                      <li className="img-item" key={i}>
                        <LazyCDNImage
                          key={item}
                          cdnUrl={item}
                          style={{ width: "80px", height: "80px" }}
                        />
                        {/* <img src={`${process.env.PUBLIC_URL}/images/tiger.png`} /> */}
                        <Button
                          className="img-close"
                          onClick={(e) => {
                            handleImgDelete(e, i);
                          }}
                        >
                          <img
                            src={`${process.env.PUBLIC_URL
                              }/images/icon/img-close.svg`}
                          />
                        </Button>
                      </li>
                    ))}
                  </ul>
                )}
                <div className="bottom-wrap" style={{ marginTop: rem(15) }}>
                  {isWeb ? (
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      component="label"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/icon/image.svg`}
                      />
                      사진첨부
                      <span className="cnt">{imgUrl.length}/3</span>
                      <input
                        type="file"
                        accept="image/*"
                        value=""
                        hidden
                        onChange={(e) => {
                          handleWebFileUpload(e);
                        }}
                      />
                    </Button>
                  ) : (
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={handleUploadImg}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/icon/image.svg`}
                      />
                      사진첨부
                      <span className="cnt">{imgUrl.length}/3</span>
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="drawer-foot">
            <Button color="primary" variant="contained" type="submit">
              {drawerMode == "modify" ? "수정완료" : "등록완료"}
            </Button>
          </div>
        </form>
      </Drawer>
    </div>
  );
}
